import React, { useMemo } from 'react';

const useDataTableInitialState = (pageSize = 25) => {
    const data = useMemo(() => ({
        pagination: { paginationModel: { pageSize, page: 0 } },
    }), [pageSize]);
    return data;
}

export default useDataTableInitialState;
